import { hrTransport } from "@/src/config/hrTransport.js";

export default {
  attendance: {
    async checkIn(payload) {
      try {
        const res = await hrTransport.post(`/attendance/check-in`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while checking in: ", error);
        throw error;
      }
    },

    async checkOut(payload) {
      try {
        const res = await hrTransport.post(`/attendance/check-out`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while checking out: ", error);
        throw error;
      }
    },

    async updateRecord(recordId, payload) {
      try {
        const res = await hrTransport.put(`/attendance/${recordId}`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while updating attendance: ", error);
        throw error;
      }
    },

    async fetchAttendance(payload) {
      try {
        const res = await hrTransport.put(`/attendance`, payload);
        return res.data;
      } catch (error) {
        console.error(
          "An error occurred while fetching attendance records: ",
          error,
        );
        throw error;
      }
    },
  },

  attendanceEditRequests: {
    async list(payload) {
      try {
        const res = await hrTransport.put(`/attendance-requests`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching edit requests: ", error);
        throw error;
      }
    },

    async approve(id, payload) {
      try {
        const res = await hrTransport.post(`/attendance-requests/${id}/approve`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while approving edit request: ", error);
        throw error;
      }
    },

    async reject(id, payload) {
      try {
        const res = await hrTransport.post(`/attendance-requests/${id}/reject`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while rejecting edit request: ", error);
        throw error;
      }
    },
  },

  time_off: {
    requests: {
      async listByUser(employeeId) {
        try {
          const res = await hrTransport.put(`/requests`, { employee_id: employeeId });
          return res.data;
        } catch (error) {
          console.error(
            "An error occurred while fetching requests by user: ",
            error,
          );
          throw error;
        }
      },

      async apply(payload) {
        try {
          const res = await hrTransport.post(`/requests`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while applying for leave: ", error);
          throw error;
        }
      },

      async fetchAllRequests() {
        try {
          const res = await hrTransport.put(`/requests`, {});
          return res.data;
        } catch (error) {
          console.error(
            "An error occurred while fetching all requests: ",
            error,
          );
          throw error;
        }
      },

      async approve(id, payload) {
        try {
          const res = await hrTransport.post(`/requests/${id}/approve`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while approving request: ", error);
          throw error;
        }
      },

      async reject(id, payload) {
        try {
          const res = await hrTransport.post(`/requests/${id}/reject`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while rejecting request: ", error);
          throw error;
        }
      },

      async fetchRequestByID(id) {
        try {
          const res = await hrTransport.get(`/requests/${id}`);
          return res.data;
        } catch (error) {
          console.error(
            "An error occurred while fetching request by ID: ",
            error,
          );
          throw error;
        }
      },

      async createRequest(payload) {
        try {
          const res = await hrTransport.post(`/requests`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while creating a request: ", error);
          throw error;
        }
      },

      async updateRequest(id, payload) {
        try {
          const res = await hrTransport.put(`/requests/${id}`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while updating a request: ", error);
          throw error;
        }
      },

      async deleteRequest(id) {
        try {
          const res = await hrTransport.delete(`/requests/${id}`);
          return res.data;
        } catch (error) {
          console.error("An error occurred while deleting a request: ", error);
          throw error;
        }
      },
    },

    leaves: {
      async fetchLeaveTypes(params) {
        try {
          const res = await hrTransport.get(`/leave-types`, params);
          return res.data;
        } catch (error) {
          console.error(
            "An error occurred while fetching leave types: ",
            error,
          );
          throw error;
        }
      },

      async fetchLeaveBalances(payload) {
        try {
          const res = await hrTransport.put(`/leave-balances`, payload);
          return res.data;
        } catch (error) {
          console.error(
            "An error occurred while fetching leave balances: ",
            error,
          );
          throw error;
        }
      },

      async create(payload) {
        try {
          const res = await hrTransport.post(`/leave-types`, payload);
          return res.data;
        } catch (error) {
          console.error(
            "An error occurred while creating a leave type: ",
            error,
          );
          throw error;
        }
      },

      async update(id, payload) {
        try {
          const res = await hrTransport.patch(`/leave-types/${id}`, payload);
          return res.data;
        } catch (error) {
          console.error(
            "An error occurred while updating a leave type: ",
            error,
          );
          throw error;
        }
      },
    },
  },

  people: {
    async findEmployeeByEmail(email) {
      try {
        const res = await hrTransport.put(`/people/employees/by-email`, { email });
        return res.data;
      } catch (error) {
        console.error("An error occurred while finding employee by email: ", error);
        throw error;
      }
    },

    async listEmployees() {
      try {
        const res = await hrTransport.put(`/people/employees`, {});
        return res.data;
      } catch (error) {
        console.error("An error occurred while listing employees: ", error);
        throw error;
      }
    },
  },

  ats: {
    campaigns: {
      async list(params) {
        try {
          const res = await hrTransport.get(`/ats/campaigns`, { params });
          return res.data;
        } catch (error) {
          console.error("An error occurred while listing ATS campaigns: ", error);
          throw error;
        }
      },
      async create(payload) {
        try {
          const res = await hrTransport.post(`/ats/campaigns`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while creating ATS campaign: ", error);
          throw error;
        }
      },
      async listLinkables(slug) {
        try {
          const res = await hrTransport.get(`/ats/linkables/${slug}`);
          return res.data;
        } catch (error) {
          console.error("An error occurred while listing ATS linkables: ", error);
          throw error;
        }
      },
      async get(id) {
        try {
          const res = await hrTransport.get(`/ats/campaigns/${id}`);
          return res.data;
        } catch (error) {
          console.error("An error occurred while fetching ATS campaign: ", error);
          throw error;
        }
      },
      async update(id, attributes) {
        try {
          const res = await hrTransport.patch(`/ats/campaigns/${id}`, { attributes });
          return res.data;
        } catch (error) {
          console.error("An error occurred while updating ATS campaign: ", error);
          throw error;
        }
      },
      async launch(id) {
        try {
          const res = await hrTransport.post(`/ats/campaigns/${id}/launch`, {});
          return res.data;
        } catch (error) {
          console.error("An error occurred while launching ATS campaign: ", error);
          throw error;
        }
      },
      async generateMessage(id, payload = {}) {
        try {
          const res = await hrTransport.post(`/ats/campaigns/${id}/generate_message`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while generating ATS message: ", error);
          throw error;
        }
      },
      async previewLeads(id, params = {}) {
        try {
          const res = await hrTransport.get(`/ats/campaigns/${id}/preview_leads`, { params });
          return res.data;
        } catch (error) {
          console.error("An error occurred while fetching ATS preview leads: ", error);
          throw error;
        }
      },
      async getSettings(id) {
        try {
          const res = await hrTransport.get(`/ats/campaigns/${id}/settings`);
          return res.data;
        } catch (error) {
          console.error("An error occurred while fetching ATS campaign settings: ", error);
          throw error;
        }
      },
      async updateSettings(id, payload) {
        try {
          const res = await hrTransport.put(`/ats/campaigns/${id}/settings`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while updating ATS campaign settings: ", error);
          throw error;
        }
      },
      async listEmailAccounts(id) {
        try {
          const res = await hrTransport.get(`/ats/campaigns/${id}/email-accounts`);
          return res.data;
        } catch (error) {
          console.error("An error occurred while listing ATS email accounts: ", error);
          throw error;
        }
      },
      async saveEmailAccounts(id, payload) {
        try {
          const res = await hrTransport.post(`/ats/campaigns/${id}/email-accounts`, payload);
          return res.data;
        } catch (error) {
          console.error("An error occurred while saving ATS email accounts: ", error);
          throw error;
        }
      },
      async deleteEmailAccount(id, emailAccountId) {
        try {
          const res = await hrTransport.delete(`/ats/campaigns/${id}/email-accounts`, {
            params: { email_account_id: emailAccountId },
          });
          return res.data;
        } catch (error) {
          console.error("An error occurred while deleting ATS email account: ", error);
          throw error;
        }
      },
      async listLaunches(id) {
        try {
          const res = await hrTransport.get(`/ats/campaigns/${id}/launches`);
          return res.data;
        } catch (error) {
          console.error("An error occurred while listing ATS launches: ", error);
          throw error;
        }
      },
    },
  },

  performance: {
    async listGoals(payload = {}) {
      try {
        const res = await hrTransport.put(`/performance`, payload);
        return res.data;
      } catch (error) {
        console.error("An error occurred while listing goals: ", error);
        throw error;
      }
    },
  },

  hr: {
    async listObjects() {
      try {
        const res = await hrTransport.get(`/hr/objects`);
        return res.data;
      } catch (error) {
        console.error("An error occurred while listing HR objects: ", error);
        throw error;
      }
    },
  },

  config: {
    async getWeekends() {
      try {
        const res = await hrTransport.get(`/hr/config/weekends`);
        return res.data;
      } catch (error) {
        console.error("An error occurred while fetching weekends: ", error);
        throw error;
      }
    },
    async setWeekends(days) {
      try {
        const res = await hrTransport.put(`/hr/config/weekends`, { days });
        return res.data;
      } catch (error) {
        console.error("An error occurred while saving weekends: ", error);
        throw error;
      }
    },
  },
};
